var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 185,
    viewBox: "0 0 340 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_101_116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.169 87.2058C132.169 87.2058 261.662 88.5121 289.699 79.9428C317.735 71.3735 317.699 26.8986 289.699 15.9355C261.698 4.97234 252.128 44.1595 252.128 44.1595",
    stroke: "white",
    strokeWidth: 20,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.636 133.946C141.636 133.946 200.717 124.91 226.764 133.946C252.811 142.983 244.517 168.906 232.173 170.091C219.829 171.276 208.439 157.546 208.439 157.546",
    stroke: "white",
    strokeWidth: 20,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4746 31.4854C61.4746 31.4854 90.3026 34.0005 124.462 34.0005C158.621 34.0005 204.922 29.2825 204.922 29.2825",
    stroke: "white",
    strokeWidth: 20,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.7 110.982H332.761L317.779 134.136L335.297 134.485L298.529 180.284L307.438 145.366H291.128L306.7 110.982Z",
    fill: "url(#paint0_linear_101_116)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8307 127.418C22.3421 127.436 37.6615 152.61 37.6615 162.393C37.6615 167.091 35.8883 171.596 32.7319 174.918C29.5755 178.24 25.2945 180.106 20.8307 180.106C16.367 180.106 12.086 178.24 8.92961 174.918C5.77323 171.596 4 167.091 4 162.393C4 152.611 19.3203 127.4 20.8307 127.418Z",
    fill: "#42A0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99879 169.013C9.68054 169.554 11.8179 167.328 12.7727 164.042C13.7275 160.755 13.1382 157.652 11.4565 157.111C9.77471 156.57 7.63735 158.795 6.68254 162.082C5.72773 165.369 6.31703 168.472 7.99879 169.013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.066 127.418C103.577 127.436 118.896 152.61 118.896 162.393C118.896 167.091 117.123 171.596 113.967 174.918C110.81 178.24 106.529 180.106 102.066 180.106C97.6018 180.106 93.3209 178.24 90.1645 174.918C87.0081 171.596 85.2349 167.091 85.2349 162.393C85.2349 152.611 100.555 127.4 102.066 127.418Z",
    fill: "#42A0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2337 169.013C90.9154 169.554 93.0528 167.328 94.0076 164.042C94.9624 160.755 94.3731 157.652 92.6913 157.111C91.0096 156.57 88.8722 158.795 87.9174 162.082C86.9626 165.369 87.5519 168.472 89.2337 169.013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5036 62.8001C62.0149 62.818 77.3344 87.992 77.3344 97.7751C77.3344 102.473 75.5611 106.978 72.4047 110.3C69.2484 113.622 64.9674 115.488 60.5036 115.488C56.0398 115.488 51.7588 113.622 48.6025 110.3C45.4461 106.978 43.6729 102.473 43.6729 97.7751C43.6729 87.993 58.9932 62.7822 60.5036 62.8001Z",
    fill: "#42A0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6716 104.396C49.3534 104.937 51.4908 102.711 52.4456 99.4241C53.4004 96.1374 52.8111 93.0342 51.1293 92.4931C49.4476 91.952 47.3102 94.1778 46.3554 97.4646C45.4006 100.751 45.9899 103.854 47.6716 104.396Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_101_116",
    x: 0,
    y: 0,
    width: 339.297,
    height: 184.284,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_101_116"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_116",
    x1: 309.149,
    y1: 145.633,
    x2: 288.278,
    y2: 138.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0AA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorm);
export default __webpack_public_path__ + "static/media/storm.0634a03e20cfdec2f38e39a0ecb6e5ce.svg";
export { ForwardRef as ReactComponent };